import type {
  ProductRoot
} from "../types/product"

export const MaybeCode = ({
  product
}: {
    product: ProductRoot
}) => {
  const categories = product.categories

  const showCode = categories.some((temp) => temp.uid === "NDM=")

  if (!showCode) { return null }

  return (
    <section className='border-t-1 my-0 border-solid border-[rgba(231,222,213)] px-0 pt-[10px] text-[0.875rem] font-semibold'>
      <div>
        5 or fewer than 5 swatches will be FREE, use code: FREESWA.
      </div>
      <div className='font-normal'>
        Swatches shipping fee can be refunded after dress purchase.
      </div>
    </section>
  )
}
